import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedListValue from '@/shared/components/FormattedListValue';
import SimplePanel from '@/shared/components/SimplePanel';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import handleHttpError from '@/shared/services/HandleHttpError';
import InlineAttachment from '@/shared/components/InlineAttachment';
import messages from '../jobMessages';
import api from '../../../shared/api';
import config from '../../../config';

class JobDetailSendRelationMail extends Component {
  state = {
    emails: [],
  };

  componentDidMount() {
    this.loadEmailContent().then(emails => {
      // console.log(emails);
      this.setState({
        emails,
      });
    });
  }

  loadEmailContent = () => {
    const { job, intl } = this.props;
    return Promise.all(
      job.parameters.emails.map(email =>
        api.base
          .get(`${config.appUrls.documents}/api/documents/view/${email.contentDocumentId}`)
          .then(({ data }) =>
            this.retrieveAttachmentInfo(job, email)
              .then(attachments => ({
                ...email,
                attachments,
                content: data,
              }))
              .catch(() => ({
                ...email,
                attachments: [],
                content: data,
              })),
          )
          .catch(error => {
            handleHttpError(intl)(error);
            return {
              ...email,
              attachments: [],
              content: '',
            };
          }),
      ),
    );
  };

  retrieveAttachmentInfo = (job, email) => {
    if (
      job.parameters.emailAttachments &&
      job.parameters.emailAttachments.length &&
      job.parameters.emailAttachments.filter(x => x.languageCode === email.languageCode).length
    ) {
      return Promise.all(
        job.parameters.emailAttachments
          .filter(x => x.languageCode === email.languageCode)
          .map(attachment =>
            api.base
              .get(`${config.appUrls.documents}/api/documents/info/${attachment.documentId}`)
              .then(response => response.data),
          ),
      );
    }
    return Promise.resolve([]);
  };

  render() {
    const { emails } = this.state;

    return emails.map(email => (
      <SimplePanel title={<FormattedListValue list="language" id={email.languageCode} />}>
        <div className="info-block container-fluid radius4B">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-md-2 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Subject} />
                    </b>
                  </label>
                </div>
                <div className="col-md-10 col-sm-6">
                  <label>{email && email.title}</label>
                </div>
              </div>
              {email && email.attachments && email.attachments.length > 0 && (
                <div className="row">
                  <div className="col-md-2 col-sm-6">
                    <label>
                      <b>
                        <FormattedMessage {...messages.Attachments} />
                      </b>
                    </label>
                  </div>
                  <div className="col-md-10 col-sm-6">
                    {email.attachments.map(attachment => (
                      <InlineAttachment key={attachment.id} attachment={attachment} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </SimplePanel>
    ));
  }
}

JobDetailSendRelationMail.propTypes = {
  job: PropTypes.shape({}).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(JobDetailSendRelationMail);
